import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "paper-texture relative min-h-screen w-full overflow-x-hidden flex flex-col font-sans bg-offWhite dark:bg-darkBg text-gray-900 dark:text-gray-100 transition-colors duration-500" };
const _hoisted_2 = { class: "flex-grow z-10 relative" };
const _hoisted_3 = { class: "container mx-auto px-6 md:px-12 max-w-7xl pt-32 md:pt-48 pb-24" };
const _hoisted_4 = { class: "container mx-auto px-6 md:px-12 max-w-7xl space-y-32 md:space-y-48 py-24 md:py-32" };
import { ref, onMounted, watch } from "vue";
import Hero from "./components/Hero.vue";
import Projects from "./components/Projects.vue";
import Skills from "./components/Skills.vue";
import Services from "./components/Services.vue";
import AboutMe from "./components/AboutMe.vue";
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
import Marquee from "./components/Marquee.vue";
import SocialLinks from "./components/SocialLinks.vue";
import { provideLanguage } from "./composables/useLanguage";
// Provide language context
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        provideLanguage();
        const darkMode = ref(false);
        onMounted(() => {
            if (typeof window !== "undefined") {
                const savedTheme = localStorage.getItem("theme");
                if (savedTheme) {
                    darkMode.value = savedTheme === "dark";
                }
                else {
                    darkMode.value = window.matchMedia("(prefers-color-scheme: dark)").matches;
                }
            }
        });
        watch(darkMode, (newValue) => {
            const root = window.document.documentElement;
            if (newValue) {
                root.classList.add("dark");
                localStorage.setItem("theme", "dark");
            }
            else {
                root.classList.remove("dark");
                localStorage.setItem("theme", "light");
            }
        });
        const toggleTheme = () => {
            darkMode.value = !darkMode.value;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createCommentVNode(" Fixed Background Grid "),
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "fixed inset-0 pointer-events-none z-0 grid-lines h-full w-full opacity-40" }, null, -1 /* CACHED */)),
                _createVNode(Header, {
                    darkMode: darkMode.value,
                    onToggleTheme: toggleTheme
                }, null, 8 /* PROPS */, ["darkMode"]),
                _createElementVNode("main", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(Hero)
                    ]),
                    _createVNode(Marquee),
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(Services),
                        _createVNode(Skills),
                        _createVNode(Projects),
                        _createVNode(AboutMe)
                    ])
                ]),
                _createVNode(Footer),
                _createVNode(SocialLinks)
            ]));
        };
    }
});
